import React, { useEffect, useState } from 'react';
import Navbar from '../navigation/Navbar';
import style from '../css/Profile.module.css';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import HeaderBar from '../components/HeaderBar';
import { FaHome, FaPowerOff } from 'react-icons/fa';

function Profile() {
	const [profile, setProfile] = useState(null);
	const navigate = useNavigate();

	useEffect(() => {
		const user = JSON.parse(localStorage.getItem('user'));
		if (user?.id) {
			axios
				.post('https://hometech-repairs.in/customerDB/get_profile.php', {
					id: user.id,
				})
				.then((res) => {
					if (res.data.status) {
						setProfile(res.data.data);
					}
				})
				.catch((err) => {
					console.error('Error fetching profile:', err);
				});
		}
	}, []);

	const handleLogout = () => {
		localStorage.clear();
		navigate('/');
	};

	return (
		<div>
			<HeaderBar
				text={'Profile'}
				icon={<FaHome color="black" size={20} />}
				navi="/dashboard"
			/>
			<div className={style.profileContainer}>
				{profile ? (
					<div className={style.infoBox}>
						<p>
							<strong>Name:</strong> <br /> {profile.name}
						</p>
						<p>
							<strong>Email:</strong> <br /> {profile.email}
						</p>
						<p>
							<strong>Phone:</strong> <br /> {profile.phone}
						</p>
						<div className={style.actions}>
							<Link className={style.reset} to={'/your-address'}>
								My Address
							</Link>
							

							<Link className={style.reset} to={'/password-reset'}>
								Password Reset
							</Link>
						</div>

						<div className={style.logout} onClick={handleLogout}>
							<FaPowerOff color="orangered" size={20} />
							<p>Log-Out</p>
						</div>

						{/* <div className={style.delete}>
								<p>Delete profile</p>
							</div> */}
					</div>
				) : (
					<p>Loading profile...</p>
				)}
			</div>

			<div style={{ textAlign: 'center', marginTop: '20px' }}>
				<p>
					© 2025 HomeTech Repairs. <br /> All rights reserved.
				</p>
			</div>
		</div>
	);
}

export default Profile;
